import styled from 'styled-components';

export const InvalidDataStyles = styled.div`
  .invalid-img {
    margin-bottom: 24px;
    display: flex;
    justify-content: center;
    img {
      height: 200px;
      width: auto;
    }
  }
  .invalid-text {
    text-align: center;
    span,
    a {
      color: ${(props) => props.theme.primary.primary50};
      display: block;
    }
    p {
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
`;
